<ion-list>
    <ion-item button (click)="dismiss('edit')" detail="false">
        <ion-label>{{ 'Edit' | translate }}</ion-label>
        <ion-icon color="secondary" slot="start" name="build"></ion-icon>
    </ion-item>

    <ion-item button (click)="dismiss('update-tournament')" detail="false">
        <ion-label>{{ 'Update tournament' | translate }}</ion-label>
        <ion-icon color="secondary" slot="start" name="refresh-outline"></ion-icon>
    </ion-item>

    <ion-item button (click)="dismiss('add-tracker')" detail="false">
        <ion-label>{{ 'Scorekeepers' | translate }}</ion-label>
        <ion-icon color="secondary" slot="start" name="person-add"></ion-icon>
    </ion-item>

    <ion-item button (click)="dismiss('venues')" detail="false">
        <ion-label>{{ 'Smart venues' | translate }}</ion-label>
        <ion-icon color="secondary" slot="start" name="bulb"></ion-icon>
    </ion-item>

    <ion-item button (click)="dismiss('add-official')" detail="false">
        <ion-label>{{ 'Officials' | translate }}</ion-label>
        <ion-icon color="secondary" slot="start" name="person-add"></ion-icon>
    </ion-item>

    <ion-item button (click)="dismiss('view-policy')" detail="false">
        <ion-label>{{ 'View Policy' | translate }}</ion-label>
        <ion-icon color="secondary" slot="start" name="people-circle-outline"></ion-icon>
    </ion-item>

    <ion-item detail="false">
        <ion-icon color="secondary" slot="start" name="megaphone-outline"></ion-icon>
        <ion-label (click)="dismiss('announcement')" style="cursor: pointer;">{{ 'Announcement' | translate }}</ion-label>
        <ion-toggle 
            slot="end" 
            [checked]="tournament.announcement?.enabled" 
            (ionChange)="toggleAnnouncement($event)">
        </ion-toggle>
    </ion-item>
    <ion-item button (click)="openNotificationModal()" detail="false">
        <ion-icon color="secondary" slot="start" name="megaphone-outline"></ion-icon>
        <ion-label>{{ 'Notification' | translate }}</ion-label>
    </ion-item>

    @if (canSubscribeToTournamentScore()) {
        <ion-item button (click)="subscribeToScoreUpdates()" detail="false">
            <ion-label>{{ 'Subscribe to Score Updates (Tournament)' | translate }}</ion-label>
            <ion-icon color="secondary" slot="start" name="notifications"></ion-icon>
        </ion-item>
    }
    @if (showExportPdf) {
        <ion-item button (click)="exportScheduleToPdf()" [disabled]="isExportingPdf" detail="false">
            <ion-label>{{ 'Export Schedule to PDF' | translate }}</ion-label>
            <ion-icon color="secondary" slot="start" name="download-outline"></ion-icon>
            @if (isExportingPdf) {
                <ion-spinner slot="end" name="crescent"></ion-spinner>
            }
        </ion-item>
    }
    @if (authService.authUserSignal()?.role?.value > 399) {
        <ion-item button (click)="dismiss('widget-status')" detail="false">
            <ion-label>{{ 'Widget Status' | translate }}</ion-label>
            <ion-icon color="secondary" slot="start" name="grid-outline"></ion-icon>
        </ion-item>
        <ion-item>
            <ion-toggle justify="space-between" 
            [checked]="tournament.allowResultSubmissionToPartner" 
            (ionChange)="allowScoreSubmission($event)">{{'Allow Result Submission To Partner' | translate}}</ion-toggle>
            <ion-icon color="secondary" slot="start" name="paper-plane"></ion-icon>
        </ion-item>

        <ion-item *ngIf="tournament?.partner === 'TMX'">
            <ion-toggle justify="space-between" 
            [disabled]="!tournament.allowResultSubmissionToPartner"
            [checked]="tournament.allowAutoSubmitScore" 
            (ionChange)="allowAutoScoreSubmissionToTmx($event)">{{'Auto Submit Scores' | translate}} ({{tournament?.partner}})</ion-toggle>
            <ion-icon color="secondary" slot="start" name="paper-plane"></ion-icon>
        </ion-item>
    }

    @if (authService.authUserSignal()?.role?.value > 399 || tournament.partner === 'manual') {
        <ion-item button (click)="dismiss('delete')" lines="none" detail="false">
            <ion-label color="danger">{{ 'Delete tournament' | translate }}</ion-label>
            <ion-icon color="danger" slot="start" name="trash"></ion-icon>
        </ion-item>
    }

</ion-list>